import { PageLanguage } from './PageLanguage';

export default PageLanguage;
